var Interface = require('../core');
var _ = require('lodash');
var moment = require('moment');

var defaultMoment = function defaultMoment(val, req) {
  if ((val === null || val === undefined) && req.rules && req.rules.defaultsToNow === false) {
    return null;
  }

  return moment();
};

var isValidMoment = function isValidMoment(val, req) {
  if ((val === null || val === undefined) && req.rules && req.rules.defaultsToNow === false) {
    return true;
  }

  return val.isValid();
};

var afterConvertToSync = function afterConvertToSync(syncValue) {
  return syncValue === null ? undefined : syncValue;
};

Interface.type('moment', {
  defaultValue: defaultMoment,
  isOfType: isValidMoment,
  afterConvertToSync: afterConvertToSync,
  convertToSync: function (sourceProp, req) {
    if ((sourceProp === null || sourceProp === undefined) && req.rules && req.rules.defaultsToNow === false) {
      return null;
    }

    return req.typeDef ? moment(sourceProp, req.typeDef) : moment(sourceProp);
  },
  convertToSource: function convertToSource(sync, req) {
    return !!sync ? sync.format(req.typeDef) : null;
  }
})
  .type('utc', {
    defaultValue: defaultMoment,
    isOfType: isValidMoment,
    afterConvertToSync: afterConvertToSync,
    convertToSync: function (sourceProp, req) {
      if ((sourceProp === null || sourceProp === undefined) && req.rules && req.rules.defaultsToNow === false) {
        return null;
      }

      return moment(sourceProp).utc();
    },
    convertToSource: function convertToSource(sync) {
      return !!sync ? sync.format(req.typeDef) : null;
    }
  })
  .type('unix', {
    defaultValue: defaultMoment,
    isOfType: isValidMoment,
    afterConvertToSync: afterConvertToSync,
    convertToSync: function (sourceProp, req) {
      if ((sourceProp === null || sourceProp === undefined) && req.rules && req.rules.defaultsToNow === false) {
        return null;
      }

      return moment.unix(sourceProp);
    },
    convertToSource: function convertToSource(sync) {
      return !!sync ? moment(sync).unix() : null;
    }
  })
  .type('timestamp', {
    defaultValue: null,
    isOfType: function (val) {
      var date = new Date(val);
      return val && typeof date.getMonth === 'function';
    },
    convertToSync: function (sourceProp, req) {
      if ((sourceProp === null || sourceProp === undefined) && req.rules && req.rules.defaultsToNow === false) {
        return null;
      }

      return sourceProp ? new Date(sourceProp).toLocaleString() : null;
    },
    convertToSource: function convertToSource(sync) {
      return !!sync ? new Date(sync).getTime() : null;
    }
  })
  .type('clock', {
    defaultValue: defaultMoment,
    isOfType: isValidMoment,
    afterConvertToSync: afterConvertToSync,
    convertToSync: function (sourceProp, req) {
      if ((sourceProp === null || sourceProp === undefined) && req.rules && req.rules.defaultsToNow === false) {
        return null;
      }

      return moment(sourceProp, 'HH:mm:ss');
    },
    convertToSource: function convertToSource(sync) {
      if (!sync) {
        return null;
      }

      sync = moment(sync, 'HH:mm:ss');
      return sync.hours() + ':' + sync.minutes() + ':' + sync.seconds();
    }
  });



// WEBPACK FOOTER //
// ./app/vendor/utility-js-interface/src/types/dates.js